import actionTypes from '../actionTypes/actionTypes';

const EDITOR_ROOT_ROUTE = '/'

export const initialState = {
  currentRoute: EDITOR_ROOT_ROUTE,
  lastRoute: EDITOR_ROOT_ROUTE
}

function routeReducer(state = initialState, action) {  
  switch (action.type) {
    case actionTypes.CHANGE_ROUTE:
      return Object.assign({}, state, {
        lastRoute: state.currentRoute || false,
        currentRoute: action.data.route || ''
      })
    default:
      return state
  }
}

export default routeReducer;